import React, { useState } from "react";
import moment from "moment";
import { DatePickerInput } from "rc-datepicker";
import { connect } from "react-redux";
// Import the default style
import "rc-datepicker/lib/style.css";
import Modal from "react-modal";

const bachelors = [
  "Bachelor of Accountancy (BAcc)",
  "Bachelor of Architecture (BArch)",
  "Bachelor of Business Administration (BBA)",
  "Bachelor of Commerce (BCom)",
  "Bachelor of Civil Law (BCL)",
  "Bachelor of Divinity (BDiv)",
  "Bachelor of Economics (BEc)",
  "Bachelor of Education (BEd)",
  "Bachelor of Engineering (BE)",
  "Bachelor of Fine Arts (BFA)",
  "Bachelor of Laws (LLB)",
  "Bachelor of Letters (BLitt)",
  "Bachelor of Music (BM)",
  "Bachelor of Pharmacy (BPharm)",
  "Bachelor of Philosophy (BPhil)",
  "Bachelor of Science in Nursing (BSN)",
  "Bachelor of Social Work (BSW)",
  "Bachelor of Technology (BTech)",
  "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
];

const masters = [
  "Licentiate in Sacred Theology (STL)",
  "Magister Juris (MJur)",
  "Master of Business Administration (MBA)",
  "Master of Counselling (MC, M.C., M.Coun., or M.Couns.)",
  "Master of Divinity (MDiv)",
  "Master of Education (MEd)",
  "Master of Engineering (MEng)",
  "Master of Fine Arts (MFA)",
  "Master of Laws (LLM)",
  "Master of Letters (MLitt)",
  "Master of Medicine (MMed)",
  "Master of Philosophy (MPhil)",
  "Master of Public Administration (MPA)",
  "Master of Public Health (MPH)",
  "Master of Research (MRes)",
  "Master of Sacred Theology (STM)",
  "Master of Science in Nursing (MSN)",
  "Master of Social Work (MSW)",
  "Master of Studies (MSt)",
  "Master of Surgery (ChM or MS)",
];

const docs = [
  "Doctor of Arts (DA)",
  "Doctor of Audiology (AuD)",
  "Doctor of Business Administration (DBA)",
  "Doctor of Canon Law (JCD)",
  "Doctor of Chiropractic (DC)",
  "Doctor of Dental Surgery (DDS)",
  "Doctor of Divinity (DDiv)",
  "Doctor of Education (EdD)",
  "Doctor of Juridical Science (JSD)",
  "Doctor of Medicine (MD)",
  "Doctor of Ministry (DMin)",
  "Doctor of Naturopathic Medicine (ND)",
  "Doctor of Osteopathic Medicine (DO)",
  "Doctor of Pharmacy (DPharm)",
  "Doctor of Philosophy (PhD)",
  "Doctor of Psychology (PsyD)",
  "Doctor of Science (DSc or ScD)",
  "Doctor of Theology (ThD)",
  "Doctor of Veterinary Medicine (DVM)",
  "Juris Doctor (JD)",
];

const areas = [
  "Balives",
  "Samrat Chowk",
  "Mahesh Society",
  "Pandhe Apartment",
  "Mantri Chandak Complex",
  "Vardhaman Nagar",
  "Mantri Chandak Nagar",
  "Bhavani Peth",
  "Budhle Galli",
  "Tuljapur Ves",
  "Mangalwar Peth",
  "Chatti Galli",
  "Bhadange Galli",
  "Navi Peth",
  "Jodbhavi Peth",
  "Geeta Dham",
  "Shelgi",
  "Akkalkot Road",
  "Saraswati Chowk",
  "Hotgi Road",
  "Vijapur Road",
  "Poona Naka",
  "Damani Nagar"
];
const maritalStatuses = ["Single", "Married"];
const relations = [
  "Father",
  "Mother",
  "Spouse",
  "Brother",
  "Son",
  "Daughter",
  "Grandfather",
  "Grandmother",
  "Daughter-In-Law",
  "Nephew", 
  "Niece", 
  "Grandson", 
  "Granddaughter",
  "Great Grandson",
  "Great Granddaughter"
];
const Qualifications = [
  "Primary School",
  "High School",
  "Junior College",
  "Under-Graduate",
  "Bachelors",
  "Masters",
  "Doctoral",
  "CA",
];
const occupations = [
  "Student",
  "Profession",
  "Business",
  "Private Service",
  "Government Service",
  "Home Maker",
];
const Businesses = [
  "Aerospace & Defense",
  "Air Freight & Logistics",
  "Airlines ",
  "Automobile Components ",
  "Automobiles ",
  "Banking ",
  "Beverages ",
  "Biotechnology ",
  "Building Products ",
  "Capital Markets ",
  "Chemicals ",
  "Commercial Services & Supplies ",
  "Communications Equipment ",
  "Construction & Engineering ",
  "Construction Materials ",
  "Consumer Finance ",
  "Containers & Packaging ",
  "Distributors ",
  "Diversified Consumer Services ",
  "Diversified Financial Services ",
  "Diversified Telecommunication Services",
  "Electric Utilities ",
  "Electrical Equipment ",
  "Electronic Equipment, Instruments & Components ",
  "Entertainment",
  "Equity Real Estate Investment Trusts",
  "Food & Staples Retailing ",
  "Food Products ",
  "Gas Utilities ",
  "Health Care Equipment & Supplies ",
  "Health Care Providers & Services ",
  "Health Care Technology ",
  "Hotels, Restaurants & Leisure ",
  "Household Durables ",
  "Household Products ",
  "IT Services ",
  "Independent Power and Renewable Electricity Producers ",
  "Industrial Conglomerates ",
  "Insurance ",
  "Interactive Media & Services",
  "Internet & Direct Marketing",
  "Leisure Products ",
  "Life Sciences Tools & Services ",
  "Machinery ",
  "Marine ",
  "Media",
  "Metals & Mining ",
  "Mortgage Real Estate Investment Trusts (REITs) ",
  "Multi-Utilities ",
  "Multiline Retail ",
  "Paper & Forest Products ",
  "Personal Products ",
  "Pharmaceuticals ",
  "Professional Services ",
  "Real Estate Management & Development",
  "Road & Rail ",
  "Semiconductors & Semiconductor Equipment ",
  "Software ",
  "Specialty Retail ",
  "Technology Hardware, Storage & Peripherals ",
  "Textile, Apparel & Luxury Goods ",
  "Thrifts & Mortgage Finance ",
  "Tobacco ",
  "Trading Companies & Distributors ",
  "Transportation Infrastructure ",
  "Water Utilities ",
  "Wireless Telecommunication Services",
];
const details = {
  Profession: [
    "Accountant",
    "Actor",
    "Actress",
    "Air traffic controller",
    "Architect",
    "Artist",
    "Attorney",
    "Banker",
    "Bartender",
    "Barber",
    "Bookkeeper",
    "Builder",
    "Butcher",
    "Carpenter",
    "Cashier",
    "Chef",
    "Coach",
    "Dental hygienist",
    "Designer",
    "Developer",
    "Dietician",
    "Doctor",
    "Economist",
    "Editor",
    "Electrician",
    "Teacher",
  ],
  Business: ["Manufacturer", "Distributor", "Trader", "Dealer"],
  "Private Service": [
    "Digital media companies",
    "Accountancy firms",
    " Hospitality and catering businesses",
    " Retail and e-commerce companies",
    " Manufacturing and construction firms",
    "Healthy and beauty businesses",
    "Technology and software developers",
  ],
  "Government Service": [
    "Central Government",
    "State Government",
    "Municipal Corporation",
    "Military",
    "Police",
    "Public Transit",
    "Infrastructure Care",
    "Public Education",
    "Health Care",
  ],
};

export class MemberForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: props.member ? props.member.firstName : "",
      middleName: props.member ? props.member.middleName : "",
      lastName: props.memberCount !== 0 ? props.members[0].lastName : "",
      relation:
        props.memberCount === 0
          ? "Self"
          : props.member
          ? props.member.relation
          : "",
      qualification: props.member ? props.member.qualification : "",
      occupation: props.member ? props.member.occupation : "",
      maritalStatus: props.member ? props.member.maritalStatus : "",
      address: props.memberCount !== 0 ? props.members[0].address : "",
      area: props.memberCount !== 0 ? props.members[0].area : "",
      degree: props.member
        ? props.member.degree !== ""
          ? props.member.degree
          : ""
        : "",
      contact: props.member ? props.member.contact.toString() : "",
      dob: props.member ? moment(props.member.dob) : moment(),
      city: props.member
        ? props.member.city
        : props.memberCount !== 0
        ? props.members[0].city
        : "Solapur",
      district: props.member
        ? props.member.district
        : props.memberCount !== 0
        ? props.members[0].district
        : "Solapur",
      state: props.member
        ? props.member.state
        : props.memberCount !== 0
        ? props.members[0].state
        : "Maharashtra",
      pincode: props.member
        ? props.member.pincode
        : props.memberCount !== 0
        ? props.members[0].pincode
        : 413001,
      professionDescription: props.member
        ? props.member.professionDescription !== ""
          ? props.member.professionDescription
          : ""
        : "",
      professionType: props.member
        ? props.member.professionType !== ""
          ? props.member.professionType
          : ""
        : "",
      calendarFocused: false,
      readOnly: false,
      error: "",
      selectedOption: undefined,
      profdesType: props.member
        ? props.member.occupation == "Business" &&
          (Businesses.indexOf(props.member.professionDescription) > -1 ||
            props.member.professionDescription === "")
          ? "dropdown"
          : "input"
        : "dropdown",
      profType: props.member
        ? !!details[props.member.occupation] &&
          (details[props.member.occupation].indexOf(
            props.member.professionType
          ) > -1 ||
            props.member.professionType === "")
          ? "dropdown"
          : "input"
        : "dropdown",
      occupationType: props.member
        ? occupations.indexOf(props.member.occupation) > -1
          ? "dropdown"
          : "input"
        : "dropdown",
      activeElementType: props.member
        ? maritalStatuses.indexOf(props.member.maritalStatus) > -1
          ? "dropdown"
          : "input"
        : "dropdown",
      degreeType: "dropdown",
    };
  }

  onfirstNameChange = (e) => {
    const firstName = e.target.value;
    this.setState(() => ({ firstName }));
  };
  onlastNameChange = (e) => {
    const lastName = e.target.value;
    this.setState(() => ({ lastName }));
  };
  onmiddleNameChange = (e) => {
    const middleName = e.target.value;
    this.setState(() => ({ middleName }));
  };
  onrelationChange = (e) => {
    const relation = e.target.value;
    this.setState(() => ({ relation }));
  };
  onqualificationChange = (e) => {
    const qualification = e.target.value;
    this.setState(() => ({ qualification }));
  };
  onmaritalStatusChange = (e) => {
    if (maritalStatuses.indexOf(e.target.value) > -1) {
      this.setState({ activeElementType: "dropdown" });
    }
    const maritalStatus = e.target.value;
    this.setState(() => ({ maritalStatus }));
  };
  onareaChange = (e) => {
    const area = e.target.value;
    this.setState(() => ({ area }));
  };
  onaddressChange = (e) => {
    const address = e.target.value;
    this.setState(() => ({ address }));
  };
  onCityChange = (e) => {
    const city = e.target.value;
    this.setState(() => ({ city }));
  };
  onDistrictChange = (e) => {
    const district = e.target.value;
    this.setState(() => ({ district }));
  };
  onpincodeChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value.length === 6) {
      this.setState({
        error: "",
      });
      fetch(`https://api.postalpincode.in/pincode/${e.target.value}`)
        .then((response) => response.text())
        .then((res) => {
          const data = JSON.parse(res);
          this.setState({
            state: data[0].PostOffice[0].State,
            city: data[0].PostOffice[0].Division,
            district: data[0].PostOffice[0].District,
          });
        })
        .catch((err) => {
          this.setState({
            error: "Invalid PIN Code",
          });
        });
    }
    if (e.target.value.length !== 6) {
      this.setState({
        city: "",
        district: "",
        state: "",
        error: "ZIP code must be of 6 digits",
      });
    }
  };
  onProfessionDescriptionChange = (e) => {
    const professionDescription = e.target.value;
    this.setState(() => ({ professionDescription }));
  };
  onContactChange = (e) => {
    const contact = e.target.value;
    if (!contact || contact.toString().length !== 11) {
      this.setState(() => ({ contact }));
    }
  };
  onDateChange = (dob) => {
    if (dob) {
      this.setState(() => ({ dob }));
    }
  };
  onFocusChange = ({ focused }) => {
    this.setState(() => ({ calendarFocused: focused }));
  };
  handleClick = (e) => {
    e.preventDefault();
    this.setState(() => ({ selectedOption: this.state.occupation }));
  };
  handleClearselectedOption = () => {
    this.setState({ selectedOption: undefined });
  };
  //// Marital Status
  dropDownChanged(e) {
    if (e.target.value === "other") {
      this.setState({ activeElementType: "input" });
    } else {
      this.setState({ activeElementType: "dropdown" });
      const maritalStatus = e.target.value;
      this.setState(() => ({ maritalStatus }));
    }
  }

  dropDownComp() {
    return (
      <select
        className="select"
        onChange={(e) => this.dropDownChanged(e)}
        value={this.state.maritalStatus}
      >
        <option value="" color="#999" disabled selected hidden>
          --Marital Status--
        </option>
        {maritalStatuses.map((el) => (
          <option key={el}>{el}</option>
        ))}
        <option value="other">Other</option>
      </select>
    );
  }

  inputFieldComp() {
    return (
      <input
        className="text-input"
        value={this.state.maritalStatus}
        onChange={this.onmaritalStatusChange}
        placeholder="Your Marital Status"
      />
    );
  }
  ////Occupation
  dropDownOccupationChanged(e) {
    if (e.target.value === "other") {
      this.setState({ occupationType: "input" });
      this.setState({ professionType: "" });
      this.setState({ professionDescription: "" });
      this.setState({ profType: "dropdown" });
    } else {
      const occupation = e.target.value;
      this.setState(() => ({ occupation }));
      this.setState({ professionType: "" });
      this.setState({ professionDescription: "" });
      this.setState({ profType: "dropdown" });
    }
  }

  onoccupationChange = (e) => {
    const occupation = e.target.value;
    this.setState(() => ({ occupation }));
    this.setState({ professionType: "" });
    this.setState({ professionDescription: "" });
    if (occupations.indexOf(occupation) > -1) {
      this.setState({ occupationType: "dropdown" });
    }
    this.setState({ profType: "dropdown" });
  };
  dropDownOccupationComp() {
    return (
      <select
        className="select"
        onChange={(e) => this.dropDownOccupationChanged(e)}
        value={this.state.occupation}
      >
        <option value="" color="#999" disabled selected hidden>
          --Occupation--
        </option>
        {occupations.map((el) => (
          <option key={el}>{el}</option>
        ))}
        <option value="other">Other</option>
      </select>
    );
  }

  inputFieldOccupationComp() {
    return (
      <input
        className="text-input"
        value={this.state.occupation}
        onChange={this.onoccupationChange}
        placeholder="Your Occupation"
      />
    );
  }

  ////profTypeField
  dropDownProfTypeChanged = (e) => {
    if (e.target.value === "other") {
      this.setState({ profType: "input" });
    } else {
      this.setState({ profType: "dropdown" });
      const professionType = e.target.value;
      this.setState(() => ({ professionType }));
    }
  };

  onprofTypeChange = (e) => {
    const professionType = e.target.value;
    this.setState(() => ({ professionType }));
    if (details[this.state.occupation].indexOf(professionType) > -1) {
      this.setState({ profType: "dropdown" });
    }
  };
  dropDownProfTypeComp() {
    return (
      <select
        className="input-group__item"
        onChange={this.dropDownProfTypeChanged}
        value={this.state.professionType}
      >
        <option value="" color="#999" disabled selected hidden>
          --Profession Type--
        </option>
        {details[this.state.occupation].map((el) => (
          <option key={el}>{el}</option>
        ))}
        <option value="other">Other</option>
      </select>
    );
  }

  inputFieldProfTypeComp() {
    return (
      <input
        className="text-input"
        type="text"
        value={this.state.professionType}
        onChange={this.onprofTypeChange}
        placeholder="Your Profession"
      />
    );
  }

  ////profDescription
  dropDownProfDesTypeChanged = (e) => {
    if (e.target.value === "other") {
      this.setState({ profdesType: "input" });
    } else {
      this.setState({ profdesType: "dropdown" });
      const professionDescription = e.target.value;
      this.setState(() => ({ professionDescription }));
    }
  };

  onprofDesTypeChange = (e) => {
    const professionDescription = e.target.value;
    this.setState(() => ({ professionDescription }));
    if (Businesses.indexOf(professionDescription) > -1) {
      this.setState({ profdesType: "dropdown" });
    }
  };
  dropDownProfDesTypeComp() {
    return (
      <select
        className="input-group__item"
        onChange={this.dropDownProfDesTypeChanged}
        value={this.state.professionDescription}
      >
        <option value="" color="#999" disabled selected hidden>
          --Profession Description--
        </option>
        {Businesses.map((el) => (
          <option key={el}>{el}</option>
        ))}
        <option value="other">Other</option>
      </select>
    );
  }

  inputFieldProfDesTypeComp() {
    return (
      <textarea
        className="text-area"
        placeholder="Profession Description"
        value={this.state.professionDescription}
        onChange={this.onprofDesTypeChange}
      ></textarea>
    );
  }

  //// Degree Field
  dropDownDegreeChanged = (e) => {
    if (e.target.value === "other") {
      this.setState({ degreeType: "input" });
    } else {
      const degree = e.target.value;
      this.setState(() => ({ degree }));
    }
  };

  OndegreeChange = (e) => {
    const degree = e.target.value;
    this.setState(() => ({ degree }));
  };

  dropDownDegreeComp() {
    return (
      <div className="input-group__item3">
        <select
          className="input-group__item"
          onChange={this.dropDownDegreeChanged}
          value={this.state.degree}
        >
          <option value="" color="#999" disabled selected hidden>
            --Degree--
          </option>
          {this.state.qualification == "Bachelors"
            ? bachelors.map((el) => <option key={el}>{el}</option>)
            : this.state.qualification == "Masters"
            ? masters.map((el) => <option key={el}>{el}</option>)
            : docs.map((el) => <option key={el}>{el}</option>)}
          <option value="other">Other</option>
        </select>
      </div>
    );
  }

  inputFieldDegreeComp() {
    return (
      <input
        className="text-input"
        type="text"
        onChange={this.OndegreeChange}
        placeholder="Your Degree"
        value={this.state.degree}
      />
    );
  }

  onSubmit = (e) => {
    e.preventDefault();

    if (this.props.memberCount === 0) {
      if (!this.state.firstName) {
        this.setState(() => ({ error: "Please provide valid First Name." }));
      } else if (!this.state.lastName) {
        this.setState(() => ({ error: "Please provide valid Last Name." }));
      } else if (!this.state.middleName) {
        this.setState(() => ({ error: "Please provide valid Middle Name." }));
      } else if (!this.state.relation) {
        this.setState(() => ({ error: "Please provide valid Relation." }));
      } else if (!this.state.qualification) {
        this.setState(() => ({ error: "Please provide valid Qualification." }));
      } else if (!this.state.maritalStatus) {
        this.setState(() => ({
          error: "Please provide valid Marital Status.",
        }));
      } else if (!this.state.occupation) {
        this.setState(() => ({ error: "Please provide valid Occupation." }));
      } else if (!this.state.address) {
        this.setState(() => ({ error: "Please provide valid Address." }));
      } else if (!this.state.area) {
        this.setState(() => ({ error: "Please provide valid Area." }));
      }
      // else if (!this.state.contact ) {
      //   this.setState(() => ({ error: 'Please provide valid Contact Number.' }));
      // }
      else if (!this.state.dob) {
        this.setState(() => ({ error: "Please provide valid Date of Birth." }));
      } else if (isNaN(this.state.contact)) {
        this.setState(() => ({ error: "Contact Number must be Numeric" }));
      } else if (
        this.state.contact.toString().length !== 10 &&
        this.state.contact.toString().length !== 0
      ) {
        this.setState(() => ({
          error: "Please provide valid Contact Number.",
        }));
      } else if (!this.state.city) {
        this.setState(() => ({ error: "Please provide valid City." }));
      } else if (!this.state.pincode) {
        this.setState(() => ({ error: "Please provide valid pincode." }));
      } else {
        this.setState(() => ({ error: "" }));
        this.props.onSubmit({
          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          relation: this.state.relation,
          qualification: this.state.qualification,
          maritalStatus: this.state.maritalStatus,
          occupation: this.state.occupation,
          address: this.state.address,
          contact: this.state.contact,
          city: this.state.city,
          district: this.state.district,
          state: this.state.state,
          pincode: this.state.pincode,
          dob: this.state.dob.valueOf(),
          area: this.state.area,
          degree: this.state.degree,
          professionType: this.state.professionType,
          professionDescription: this.state.professionDescription,
          CreatedAT: new Date(),
        });
      }
    } else {
      if (!this.state.firstName) {
        this.setState(() => ({ error: "Please provide valid First Name." }));
      } else if (!this.state.lastName) {
        this.setState(() => ({ error: "Please provide valid Last Name." }));
      } else if (!this.state.middleName) {
        this.setState(() => ({ error: "Please provide valid Middle Name." }));
      } else if (!this.state.relation) {
        this.setState(() => ({ error: "Please provide valid Relation." }));
      } else if (!this.state.qualification) {
        this.setState(() => ({ error: "Please provide valid Qualification." }));
      } else if (!this.state.maritalStatus) {
        this.setState(() => ({
          error: "Please provide valid Marital Status.",
        }));
      } else if (!this.state.occupation) {
        this.setState(() => ({ error: "Please provide valid Occupation." }));
      }
      // else if (!this.state.contact ) {
      //   this.setState(() => ({ error: 'Please provide valid Contact Number.' }));
      // }
      else if (!this.state.dob) {
        this.setState(() => ({ error: "Please provide valid Date of Birth." }));
      } else if (isNaN(this.state.contact)) {
        this.setState(() => ({ error: "Contact Number must be Numeric" }));
      } else if (
        this.state.contact.toString().length !== 10 &&
        this.state.contact.toString().length !== 0
      ) {
        this.setState(() => ({
          error: "Please provide valid Contact Number.",
        }));
      } else if (!this.state.city) {
        this.setState(() => ({ error: "Please provide valid City." }));
      } else if (!this.state.pincode) {
        this.setState(() => ({ error: "Please provide valid pincode." }));
      } else {
        this.setState(() => ({ error: "" }));
        this.props.onSubmit({
          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          relation: this.state.relation,
          qualification: this.state.qualification,
          maritalStatus: this.state.maritalStatus,
          occupation: this.state.occupation,
          address: this.state.address,
          contact: this.state.contact,
          area: this.state.area,
          degree: this.state.degree,
          city: this.state.city,
          district: this.state.district,
          state: this.state.state,
          pincode: this.state.pincode,
          professionType: this.state.professionType,
          professionDescription: this.state.professionDescription,
          dob: this.state.dob.valueOf(),
          CreatedAT: new Date(),
        });
      }
    }
  };
  render() {
    return (
      <form onSubmit={this.onSubmit} className="form">
        <div className="input-group__items">
          <input
            type="text"
            placeholder="Surname"
            className="text-input"
            value={this.state.lastName}
            onChange={this.onlastNameChange}
          />
          <input
            type="text"
            placeholder="First Name"
            autoFocus
            className="text-input"
            value={this.state.firstName}
            onChange={this.onfirstNameChange}
          />
          <input
            type="text"
            placeholder="Middle Name"
            className="text-input"
            value={this.state.middleName}
            onChange={this.onmiddleNameChange}
          />
        </div>

        <div className="contentwithlabelqual">
          <p className="input-group__item3">Qualification</p>
          <select
            required
            className="select"
            value={this.state.qualification}
            onChange={this.onqualificationChange}
          >
            <option value="" color="#999" disabled selected hidden>
              --Qualification--
            </option>
            {Qualifications.map((el) => (
              <option key={el}>{el}</option>
            ))}
            <option value="other">Other</option>
          </select>
          {(this.state.qualification == "other" && (
            <input
              type="text"
              className="text-input"
              id="otherdegree"
              value={this.state.degree}
              onChange={this.OndegreeChange}
              placeholder="Your Degree"
            />
          )) ||
            ((this.state.qualification == "Bachelors" ||
              this.state.qualification == "Masters" ||
              this.state.qualification == "Doctoral") &&
              (this.state.degreeType == "dropdown" ||
              (this.props.member &&
                (this.props.member.degree in bachelors ||
                  this.props.member.degree in masters ||
                  this.props.member.degree in docs))
                ? this.dropDownDegreeComp()
                : this.inputFieldDegreeComp()))}
        </div>

        {this.props.memberCount === 0 ||
        (this.props.member && this.props.member.relation == "Self") ? (
          // <div className='input-group__item'>
          <div className="contentwithlabel">
            <p className="input-group__item3">Relation with the Head</p>
            <p className="input-group__item2"> {this.state.relation}</p>
          </div>
        ) : (
          <div className="contentwithlabel">
            <p className="input-group__item3">Relation with the Head</p>
            <select
              required
              className="select"
              value={this.state.relation}
              onChange={this.onrelationChange}
              placeholder="Relation"
            >
              <option value="" color="#999" disabled selected hidden>
                --Relation--
              </option>
              {relations.map((el) => (
                <option key={el}>{el}</option>
              ))}
            </select>
          </div>
        )}
        <div className="contentwithlabelqual">
          <p className="input-group__item3">Occupation</p>
          {this.state.occupationType == "dropdown" ||
          (this.props.member && this.props.member.occupation in occupations)
            ? this.dropDownOccupationComp()
            : this.inputFieldOccupationComp()}
          {details[this.state.occupation] && (
            <button className="button" onClick={this.handleClick} type="button">
              Add Professional Details
            </button>
          )}
        </div>

        <Modal
          isOpen={!!this.state.selectedOption}
          onRequestClose={this.handleClearselectedOption}
          contentLabel="Professional Details"
          className="modal"
        >
          <h3 className="modal__title">Professional Details</h3>
          {!!this.state.selectedOption && (
            <div className="modal__body">
              <div className="modal__fields">
                {this.state.profType === "dropdown"
                  ? this.dropDownProfTypeComp()
                  : this.inputFieldProfTypeComp()}
              </div>
              <div className="modal__fields">
                {this.state.occupation == "Business" ? (
                  this.state.profdesType === "dropdown" ? (
                    this.dropDownProfDesTypeComp()
                  ) : (
                    this.inputFieldProfDesTypeComp()
                  )
                ) : (
                  <textarea
                    className="text-area"
                    placeholder="Profession Description"
                    value={this.state.professionDescription}
                    onChange={this.onProfessionDescriptionChange}
                  ></textarea>
                )}
              </div>
              <button
                className="button"
                type="button"
                onClick={this.handleClearselectedOption}
              >
                Save Details
              </button>
            </div>
          )}
        </Modal>

        <div className="contentwithlabel">
          <p className="input-group__item3">Date of Birth (DD/MM/YYYY) </p>
          <DatePickerInput
            label="Date of Birth"
            placeholder="Date of Birth"
            onChange={this.onDateChange}
            value={this.state.dob}
            displayFormat="DD/MM/YYYY"
          />
        </div>

        <div className="contentwithlabel">
          <p className="input-group__item3">Contact Number</p>
          <input
            type="text"
            className="text-input"
            placeholder="Contact Number"
            value={this.state.contact}
            onChange={this.onContactChange}
          />
        </div>

        <div className="contentwithlabel">
          <p className="input-group__item3">Marital Status</p>
          {this.state.activeElementType == "dropdown" ||
          (this.props.member &&
            this.props.member.maritalStatus in maritalStatuses)
            ? this.dropDownComp()
            : this.inputFieldComp()}
        </div>

        <div className="contentwithlabel">
          <p className="input-group__item3">Area of Residence</p>
          {this.props.memberCount === 0 ? (
            <select
              required
              className="select"
              value={this.state.area}
              onChange={this.onareaChange}
            >
              <option value="" color="#999" disabled selected>
                --Area--
              </option>
              {areas.map((el) => (
                <option key={el}>{el}</option>
              ))}
            </select>
          ) : (
            <p className="input-group__item2"> {this.state.area}</p>
          )}
        </div>

        <div className="contentwithlabelqual2">
          <div className="districtcity">
            <div className="flexing">
              <p className="input-group__item3">Pincode</p>

              <input
                maxLength={6}
                minLength={6}
                onChange={this.onpincodeChange}
                name="pincode"
                placeholder=" "
                value={this.state.pincode}
                id="pincode"
                type="number"
                class="input-group__item2"
                required
              />
            </div>
            <div className="flexing">
              <p className="input-group__item3">City</p>

              <input
                type="String"
                readonly
                placeholder="City"
                value={this.state.city}
                class="input-group__item2"
                required
              />
            </div>
          </div>
          <div className="districtcity">
            <div className="flexing">
              <p className="input-group__item3">District</p>
              <input
                type="String"
                placeholder="District"
                readonly
                value={this.state.district}
                class="text-input"
                required
              />
            </div>
            <div className="flexing">
              <p className="input-group__item3">State</p>

              <input
                type="String"
                placeholder="State"
                readonly
                value={this.state.state}
                class="text-input"
                required
              />
            </div>
          </div>
        </div>

        <p className="input-group__item2"> Address : {this.state.address}</p>

        {this.state.error && <p className="form__error">*{this.state.error}</p>}
        <button className="button" type="submit">
          Save Member Details
        </button>
      </form>
    );
  }
}
const mapStateToProps = (state) => {
  const visibleMembers = state.members;

  return {
    members: visibleMembers,
    memberCount: visibleMembers.length,
  };
};

export default connect(mapStateToProps)(MemberForm);



// WEBPACK FOOTER //
// ./src/components/MemberForm.js